import { useDisconnect as useWagmiDisconnect } from 'wagmi';

export const useDisconnect = () => {
  const { connectors, disconnectAsync } = useWagmiDisconnect();

  const disconnect = async () => {
    await Promise.all(
      connectors.map(async (connector) => {
        try {
          await disconnectAsync({ connector });
        } catch (err) {
          console.log('disconnect error', err);
        }
      })
    );
  };

  return { disconnect };
};
